// ============================================================
// Preview SPK setelah simpan — auto cetak struk + QR tracking
// ============================================================

import Alpine from 'alpinejs';
import QRCode from 'qrcode';

Alpine.data('spkPreview', (config = {}) => ({
  spkId: config.spkId,
  printUrl: config.printUrl || '',
  printViewUrl: config.printViewUrl || '',
  indexUrl: config.indexUrl || '/kasir-panel/spk',
  trackingScanUrl: config.trackingScanUrl || '',
  isPrinting: false,
  printed: false,
  qrError: '',

  async init() {
    await this.$nextTick();
    await this.renderTrackingQr();
    setTimeout(() => this.autoPrint(), 400);
  },

  async renderTrackingQr() {
    this.qrError = '';
    if (!this.trackingScanUrl) return;

    const el = document.getElementById('spk-preview-qr');
    if (!el) return;

    el.innerHTML = '<span class="text-xs text-gray-400">Memuat QR...</span>';

    try {
      const canvas = await QRCode.toCanvas(this.trackingScanUrl, {
        width: 140,
        margin: 2,
        errorCorrectionLevel: 'M',
      });
      el.innerHTML = '';
      canvas.classList.add('mx-auto', 'rounded');
      canvas.setAttribute('role', 'img');
      canvas.setAttribute('aria-label', 'QR Code lacak produksi SPK');
      el.appendChild(canvas);
    } catch (err) {
      console.error('SPK preview QR failed:', err);
      this.qrError = 'QR gagal dimuat.';
      el.innerHTML = '<span class="text-xs text-red-500">QR gagal dimuat</span>';
    }
  },

  async autoPrint() {
    if (this.printed) return;
    await this.printReceipt();
  },

  async printReceipt() {
    if (this.isPrinting) return;
    this.isPrinting = true;

    try {
      if (this.printViewUrl) {
        window.open(this.printViewUrl, 'PRINT_SPK', 'width=420,height=760');
        this.printed = true;
        return;
      }

      const { data } = await axios.post(this.printUrl);
      if (data?.data?.receipt?.print_view_url) {
        window.open(data.data.receipt.print_view_url, 'PRINT_SPK', 'width=420,height=760');
        this.printed = true;
      } else if (data?.data?.receipt) {
        window.printThermal?.(data.data.receipt);
        this.printed = true;
      }
    } catch {
      window.toast?.('Gagal mencetak SPK.', 'error');
    } finally {
      this.isPrinting = false;
    }
  },
}));
